module.exports = __webpack_public_path__ + "static/img/msg_tab6.101dc8d9.png";